import React, {useEffect, useState} from 'react'
import Cookies from 'universal-cookie'
import DefaultLoading from 'src/common/razzle-platform-translate/Translate/GoogleTranslate/components/DefaultLoading'
import DefaultTranslateButton from 'src/common/razzle-platform-translate/Translate/GoogleTranslate/components/DefaultTranslateButton'
import { useIntl } from 'react-intl'
import { GOOGLE_TRANSLATE_API_KEY} from 'src/common/razzle-platform-translate/configs'


const GoogleTranslate = (props) => {
    const [displayTranslatedText, setDisplayTranslatedText] = useState(false)
    const [inProgress, setInProgress] = useState(false)
    const [originalText, setOriginalText] = useState(null)
    const [translatedText, setTranslatedText] = useState(null)

    const { formatMessage } = useIntl()

    useEffect(() => {
        setOriginalText(props.text)
    }, [])

    const translate = () => {
        if (!displayTranslatedText) {
            if (!translatedText) {
                setInProgress(true)
                // Initialize the google translate api
                const googleTranslate = require("google-translate")(GOOGLE_TRANSLATE_API_KEY)
                // Get current user locale from cookie or from the browser default language
                const cookies = new Cookies();
                const locale = cookies.get('pll_language') || navigator.language
                // Make a request to google translate api
                googleTranslate.translate(originalText, locale, function(err, translation) {
                    if (translation && translation.translatedText) {
                        setTranslatedText(translation.translatedText)
                        setDisplayTranslatedText(true)
                    }
                    setInProgress(false)
                })
            } else {
                setDisplayTranslatedText(true)
            }
        } else {
            setDisplayTranslatedText(false)
        }
    }

    const TranslateButton = () => {
        const ButtonComponent = props.translateButton
        return (
            <ButtonComponent
                onClick={translate}
                inProgress={inProgress}
                showTranslateTextLabel={formatMessage({ id: 'Voir la traduction', defaultMessage: 'Voir la traduction'})}
                showDefaultTextLabel={formatMessage({ id: 'Voir default text', defaultMessage: 'Voir default text'})}
                displayTranslateText={displayTranslatedText}
            />
        )
    }

    const Loading = () => {
        const LoadingComponent = props.loading
        // We use this component to display loading instead of text when we make a request
        return <LoadingComponent inProgress={inProgress} />
    }

    const text = displayTranslatedText ? translatedText : originalText

    return (props.children({text, TranslateButton, Loading: inProgress ? Loading : null}))
}

GoogleTranslate.defaultProps = {
	translateButton: DefaultTranslateButton,
	loading: DefaultLoading
}

export default GoogleTranslate
